import { createPortal } from "react-dom";
import type { ReactNode } from "react";

/** Outside the header group so fixed positioning follows the viewport. */
export function MobileCreateAction({ children }: { children: ReactNode }) {
  return createPortal(<div data-mobile-create>{children}</div>, document.body);
}
